import ReactDOM from 'react-dom';
import { IntercomProvider } from 'react-use-intercom';
// TODO: OneA-in-Core feature : must be imported in top level
// import '@utils/saasCookieManager';
import './index.scss';
import './setupServiceWorkers';
import { INTERCOM_APP_ID } from '@utils/constants';
import App from '@components/App';
import AppWrapper from '@components/AppWrapper';
import { initSentry } from '@utils/tracking';

if (
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_SENTRY_RELEASE
) {
    initSentry();
}

// ResizeObserver loop limit exceeded is a benign error and can be safely ignored
// It was ignored because it ruins our crashfree stats despite not being a crash.
// More info: https://stackoverflow.com/a/50387233
window.onerror = (msg: string | Event) => {
    switch (msg) {
        case 'ResizeObserver loop completed with undelivered notifications.':
        case 'ResizeObserver loop limit exceeded':
            return true;
        default:
            return false;
    }
};

window?.addEventListener('beforeunload', () => {
    if ('serviceWorker' in navigator) {
        void navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => {
                registrations.forEach((worker) => {
                    void worker.unregister();
                });
            });
    }
});

/**
 * React.StrictMode is temporally disbled due to Mui datepicker issue
 * It will be added after upgrading the next Mui datepicker.
 */
ReactDOM.render(
    <AppWrapper>
        <IntercomProvider appId={INTERCOM_APP_ID}>
            <App />
        </IntercomProvider>
    </AppWrapper>,
    document.getElementById('root'),
);
